module.exports = __webpack_public_path__ + "img/premier-web__website.2eb61e3b.jpg";